
import React from 'react';

interface HeroProps {
  onLaunchPortfolio?: () => void;
  onMeetStudio?: () => void;
}

const Hero: React.FC<HeroProps> = ({ onLaunchPortfolio, onMeetStudio }) => {
  return (
    <section className="relative h-full w-full flex items-center justify-center overflow-hidden bg-background-dark">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background-dark/40 to-background-dark z-10"></div>
        <img 
          alt="Premium studio background" 
          className="w-full h-full object-cover grayscale brightness-[0.4] contrast-125" 
          src="https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=2000&auto=format&fit=crop" 
        />
      </div>
      <div className="relative z-20 text-center px-6 max-w-6xl">
        <h1 className="text-[clamp(2.5rem,10vw,7rem)] font-black leading-[0.9] tracking-tighter uppercase mb-12">
          Design-led apps <br/>
          <span className="text-stroke italic">built</span> <span className="text-primary italic">for real life.</span>
        </h1>
        <div className="flex flex-col md:flex-row items-center justify-center gap-12">
          <p className="text-base lg:text-lg text-white/80 max-w-[400px] leading-tight text-left border-l-2 border-primary pl-6">
            We craft premium digital experiences that blend high-end editorial aesthetics with robust engineering.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto">
            <button 
              onClick={onLaunchPortfolio}
              className="bg-primary text-white px-10 py-5 font-black text-xs tracking-[0.2em] uppercase hover:bg-white hover:text-black transition-all"
            >
              Launch Portfolio
            </button>
            <button 
              onClick={onMeetStudio}
              className="border border-white/20 text-white px-10 py-5 font-black text-xs tracking-[0.2em] uppercase backdrop-blur-sm hover:bg-white hover:border-white hover:text-black transition-all"
            >
              Meet The Studio
            </button>
          </div>
        </div>
      </div>
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce opacity-30">
        <span className="material-symbols-outlined text-4xl text-white font-thin">expand_more</span>
      </div>
    </section>
  );
};

export default Hero;
